import getLeadsStaffFilters from './leads-staff-filters';

export default {
  getLeadsStaffFilters,
};
